import accountDetailsEL from "./accountDetails.json";
import alertsEL from "./alerts.json";
import barringsEL from "./barrings.json";
import billsEL from "./bills.json";
import forgotEmailEL from "./forgotEmail.json";
import glossaryEL from "./glossary.json";
import navigationEL from "./navigation.json";
import orderEL from "./order.json";
import paymentEL from "./payment.json";
import portinEL from "./portin.json";
import profileEL from "./profile.json";
import simEL from "./sim.json";
import controlEL from "./control.json";
import monthEL from "./month.json";
import usageEL from "./usage.json";
import commonTranslationEL from "./common.json";
import footerTranslationEL from "./footer.json";
import headerTranslationEL from "./header.json";
import selectReasonTranslationEL from "./selectReason.json";
import addressTranslationEL from "./address.json";
import validationTranslationEL from "./validation.json";
import contactEL from "./contact.json";

export const ELalerts = alertsEL;

export const ELbarrings = barringsEL;

export const ELbills = billsEL;

export const ELcontrol = controlEL;

export const ELglossary = glossaryEL;

export const ELforgotEmail = forgotEmailEL;

export const ELnavigation = navigationEL;

export const ELaccountDetails = accountDetailsEL;

export const ELorder = orderEL;

export const ELpayment = paymentEL;

export const ELportin = portinEL;

export const ELprofile = profileEL;

export const ELsim = simEL;

export const ELmonth = monthEL;

export const ELusage = usageEL;

export const ELcommon = commonTranslationEL;

export const ELfooter = footerTranslationEL;

export const ELheader = headerTranslationEL;

export const ELselectReason = selectReasonTranslationEL;

export const ELaddress = addressTranslationEL;

export const ELvalidation = validationTranslationEL;

export const ELcontact = contactEL;
